const initialState = {
  activeAudio: null,
  showSidebar: false,
  showModal: false,
  loading: false,
  timeout: false,
  relatedSearches: {
    recommendations: []
  },
  resultsUrl: '',
  results: {
    aggregations: {},
    matches: [],
    total_hits: 0,
    term: ''
  },
  seoMeta: {
    heading: null,
    sub_heading: null,
    title: 'Envato Market',
    meta_description: 'Over 3 million digital products created by a global community of designers, developers, photographers, illustrators &amp; producers.'
  },
  studioRecommendations: {
    generation: null,
    items: []
  },
  ingestedContent: null
}

export default function searchPage (state = initialState, action) {
  switch (action.type) {
    case 'setActiveAudio':
      return {
        ...state,
        activeAudio: action.payload.activeAudio
      }

    case 'fetchSearchResultsRequest':
      return {
        ...state,
        loading: true,
        timeout: false,
        relatedSearches: {
          recommendations: []
        }
      }

    case 'fetchSearchResultsSuccess':
      return {
        ...state,
        results: action.payload.results,
        resultsUrl: action.payload.resultsUrl,
        loading: false
      }

    case 'fetchSearchResultsFailure':
      return {
        ...state,
        loading: false,
        timeout: action.timeout
      }

    case 'fetchRecommendedSearchesByTermResultsSuccess':
      return {
        ...state,
        relatedSearches: {
          type: 'term',
          recommendations: action.payload.recommendations,
          hint: action.payload.hint
        }
      }

    case 'fetchRecommendedSearchesByCategoryResultsSuccess':
      return {
        ...state,
        relatedSearches: {
          type: action.payload.type,
          recommendations: action.payload.recommendations,
          hint: action.payload.hint
        }
      }

    case 'setSeoData':
      return {
        ...state,
        seoMeta: action.payload.seoMeta || initialState.seoMeta
      }

    case 'setStudioRecommendations':
      return {
        ...state,
        studioRecommendations: action.payload
      }

    case 'fetchIngestedContentSuccess':
      return {
        ...state,
        ingestedContent: action.payload.content || initialState.ingestedContent
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./common/reducers/searchPage.js